<template>
  <div>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column type="expand">
        <template slot-scope="scope">
          <p v-html="scope.row.question.name"></p>
          <p v-for="(item, index) in scope.row.option" :key="index">
            <span v-if="scope.row.question.type != 4">{{ code[index] }}:</span
            >{{ item.name }}
            <span style="color:#409eff" v-if="item.is_right == 1"
              >(正确选项)</span
            >
          </p>
        </template>
      </el-table-column>
      <el-table-column label="No." type="index" width="50"></el-table-column>
      <el-table-column label="题型" align="center">
        <template slot-scope="scope">
          <el-link
            :type="
              scope.row.question.type == 1
                ? 'success'
                : scope.row.question.type == 2
                ? 'warning'
                : scope.row.question.type == 3
                ? 'primary'
                : 'info'
            "
            ><span v-if="scope.row.question.type == 1">单选题</span>
            <span v-if="scope.row.question.type == 2">多选题</span>
            <span v-if="scope.row.question.type == 3">判断题</span>
            <span v-if="scope.row.question.type == 4">填空题</span></el-link
          >
        </template>
      </el-table-column>

      <el-table-column
        label="本题分数"
        prop="paper_question.score"
        align="center"
      >
      </el-table-column>
      <el-table-column label="得分" align="center">
        <template slot-scope="scope">
          {{ scope.row.is_right == 1 ? scope.row.paper_question.score : 0 }}
        </template>
      </el-table-column>
      <el-table-column label="学员输入内容" prop="select" align="center">
        <template slot-scope="scope">
          <span :style="{ color: scope.row.is_right == 1 ? '' : 'red' }">
            {{ scope.row.select }}</span
          >
        </template>
      </el-table-column>
      <el-table-column label="标准答案" align="center">
        <template slot-scope="scope">
          <span v-for="(item, index) in scope.row.option" :key="index">
            <span v-if="item.is_right && scope.row.question.type == 4"
              >{{ item.name
              }}<em v-if="index != scope.row.option.length - 1">
                /
              </em></span
            >
            <span v-if="item.is_right && scope.row.question.type == 3">{{
              item.name
            }}</span>
            <span
              v-if="
                item.is_right &&
                  (scope.row.question.type == 1 || scope.row.question.type == 2)
              "
              >{{ code[index] }}</span
            >
          </span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tableData: [],
      code: ["A", "B", "C", "D", "E", "F", "G"],
    };
  },
  created() {
    this.init();
  },
  mounted() {},

  methods: {
    init() {
      let _this = this;
      let id = this.$route.params.id;
      _this.$http
        .get(process.env.VUE_APP_URL + "results/resultQuestionInfo/" + id)
        .then(function(data) {
          if (data.data.code == 200) {
            _this.tableData = data.data.data.question;

            _this.tableData.forEach((item, i) => {
              if (item.question.type == 1) {
                //单选
                let obj = item.option.find((e, index) => {
                  e.index = index;
                  return e.id == item.seleted;
                });
                if (obj) {
                  item.select = _this.code[obj.index];
                }
              }
              if (item.question.type == 2) {
                //多选
                let arr = item.seleted.split(",");
                let select_arr = [];
                arr.forEach((ele) => {
                  let obj = item.option.find((e, index) => {
                    e.index = index;
                    return e.id == ele;
                  });
                  if (obj) {
                    select_arr.push(_this.code[obj.index]);
                    item.select = select_arr.toString();
                  }
                });
              }
              if (item.question.type == 3) {
                //判断
                let obj = item.option.find((e) => {
                  return e.id == item.seleted;
                });
                if (obj) {
                  item.select = obj.name;
                }
              }
              if (item.question.type == 4) {
                //填空
                item.select = item.seleted;
              }
            });
          }
        })
        .catch(function(error) {
          _this.$message.error("网络错误,请刷新界面重试");
          return;
        });
    },
  },
};
</script>
<style lang="less" scoped></style>
